export default {"src":"/_next/static/media/hexwrench_24.19134d99.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};